import { render, staticRenderFns } from "./SelfDefense.vue?vue&type=template&id=0c769311&scoped=true&"
import script from "./SelfDefense.vue?vue&type=script&lang=js&"
export * from "./SelfDefense.vue?vue&type=script&lang=js&"
import style0 from "./SelfDefense.vue?vue&type=style&index=0&id=0c769311&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c769311",
  null
  
)

export default component.exports